import { render, staticRenderFns } from "./CostumeShop.vue?vue&type=template&id=8f7e0814&scoped=true"
import script from "./CostumeShop.vue?vue&type=script&lang=ts"
export * from "./CostumeShop.vue?vue&type=script&lang=ts"
import style0 from "./CostumeShop.vue?vue&type=style&index=0&id=8f7e0814&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../front/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8f7e0814",
  null
  
)

export default component.exports